/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

'use client';

import { useContext } from 'react';
import { EvaluateContext } from '@/context';

export const useEvals = () => {
  return useContext(EvaluateContext);
};
